import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Needs - Get All (Read)
export const GetAllNeeds = createAsyncThunk(
  "productmanage/needs/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.ProductManage.Needs}?name=${filter?.name || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Needs - Get (Read)
export const GetNeeds = createAsyncThunk(
  "productmanage/needs/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.ProductManage.Needs}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Needs - Create (Add)
export const AddNeeds = createAsyncThunk(
  "productmanage/needs/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.ProductManage.Needs, data);
      return res; // The new needs object
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Needs - Update
export const UpdateNeeds = createAsyncThunk(
  "productmanage/needs/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      
      const res = await PUT(`${APIS.ProductManage.Needs}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Needs - Delete
export const DeleteNeeds = createAsyncThunk(
  "productmanage/needs/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.ProductManage.Needs}/${id}`);
      return id; // Return the id of the deleted needs
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Needs - Status
export const StatusNeeds = createAsyncThunk(
  "productmanage/needs/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ProductManage.Needs}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const needsSlice = createSlice({
  name: "needs",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetNeeds, AddNeeds, UpdateNeeds, DeleteNeeds
      .addCase(GetAllNeeds.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllNeeds.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllNeeds.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetNeeds.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetNeeds.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetNeeds.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddNeeds.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddNeeds.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddNeeds.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateNeeds.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateNeeds.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (needs) => needs.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateNeeds.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteNeeds.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteNeeds.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (needs) => needs.id !== action.payload.id
        ); // Remove the needs with the deleted id
      })
      .addCase(DeleteNeeds.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusNeeds.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusNeeds.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (needs) => needs.id !== action.payload.id
        ); // Remove the needs with the deleted id
      })
      .addCase(StatusNeeds.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = needsSlice.actions;

export default needsSlice.reducer;
